// extracted by mini-css-extract-plugin
module.exports = {"header-volume-button":"header-volume-button_header-volume-button__bOX_V"};